import { render, staticRenderFns } from "./AnswerSet.vue?vue&type=template&id=4d7933e6&"
import script from "./AnswerSet.vue?vue&type=script&lang=js&"
export * from "./AnswerSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports